export const Project = [
  {
    title: "tinkerhub bootcamp app[Movie app]",
    name: "Movie App",
    tools: ["dart", "flutter", "figma"],
    desc: "A Flutter-based movie app developed as part of a TinkerHub bootcamp. This app showcases the fundamentals of Flutter, including API integration, use of modern packages, and efficient data modeling with build_runner. Designed with Figma, the app provides an engaging user experience while demonstrating best practices in Flutter development.",
    year:'2025',
    link: "https://github.com/badu01/tinkerhub_bootcamp_app.git",
    type: "code",
    src:"github"
  },
  {
    title: "rural commerce website",
    name: "Commerce Website",
    tools: ["react", "tailwind"],
    desc: "A responsive and user-friendly website developed for a TinkerHub project initiative. Designed to empower rural commerce, the platform leverages modern web technologies like React and Tailwind CSS to deliver a seamless user experience while showcasing efficient design and development practices.",
    year:'2024',
    link: "https://github.com/badu01/rural_commerce.git",
    type: "code",
    src:"github"
  },
  {
    title: "movie nation",
    name: "Movie Nation",
    tools: ["dart", "flutter", "figma"],
    desc: "An engaging Flutter app leveraging the TMDB API to display movie data. This project focuses on mastering state management using the Flutter Bloc pattern while integrating modern API handling techniques. It serves as a hands-on introduction to efficient Flutter development and Bloc concepts.",
    year:'2024',
    link: "https://github.com/badu01/Movie_Nation.git",
    type: "code",
    src:"github"
  },
  {
    title: "to do",
    name: "To Do App",
    tools: ["dart", "flutter"],
    desc: "Developed a Flutter app to explore and implement Hive, a lightweight and fast NoSQL database. This project focuses on mastering local data storage, retrieval, and management in Flutter, providing a seamless and efficient offline user experience",
    year:'2024',
    link: "https://github.com/badu01/MyTodo.git",
    type: "code",
    src:"github"
  },
  {
    title: "where is my bus",
    name: "Where Is My Bus",
    tools: ["dart", "flutter"],
    desc: "Developed a Flutter app for a hackathon conducted by NSS College, Palakkad, addressing the challenge of public transport navigation. The app provides accurate bus timings and schedules, designed to assist users unfamiliar with the area, ensuring a smoother and more convenient travel experience in new locations.",
    year:'2024',
    link: "https://github.com/badu01/where_is_my_bus.git",
    type: "code",
    src:"github"
  },
  {
    title: "netflix clone [study_project]",
    name: "Netflix Clone",
    tools: ["react"],
    desc: "Developed a Netflix clone website as part of my React learning journey. This project replicates the core UI and functionality of Netflix, including fetching and displaying movie data using APIs, implementing responsive design, and gaining hands-on experience with React components, state management, and hooks.",
    year:'2024',
    link: "https://github.com/badu01/netflix_clone.git",
    type: "code",
    src:"github"
  },
  {
    title: "pishguard",
    name: "PhishGuard",
    tools: ["dart", "flutter"],
    desc: "Created an anti-phishing application during a hackathon at Christ College, Irinjalakuda. The app addresses the issue of phishing by analyzing clicked links in real time. If a link is identified as a phishing attempt, the app immediately warns the user and blocks access, ensuring secure browsing and enhancing online safety.",
    year:'2024',
    link: "https://github.com/badu01/phishguard.git",
    type: "code",
    src:"github"
  },
  {
    title: "eazyGo",
    name: "EazyGo",
    tools: ["dart", "flutter",'figma'],
    desc: "Developed as our diploma final year project, this app simplifies reporting infrastructure issues like road potholes, electric line breaks, and water leakages. It enables citizens to easily notify the respective authorities, ensuring faster resolution and improved community infrastructure.",
    year:'2023',
    link: "https://github.com/badu01/eazygo_project.git",
    type: "code",
    src:"github"
  },
  {
    title: "eazyGo UI",
    name: "EazyGo UI",
    tools: ['figma'],
    desc: "Designed a user-friendly and intuitive interface for EazyGo, focusing on enhancing the user experience for easy navigation and accessibility in travel-related tasks.",
    year:'2023',
    link: "https://www.figma.com/community/file/1276466328731796485/eazygo",
    type: "ui/ux",
    src:"figma"
  },
  {
    title: "onam poster",
    name: "Onam Poster",
    tools: ['photoshop'],
    desc: "Designed a vibrant and culturally inspired Onam poster featuring a modern twist with traditional elements. The poster captures the essence of the festival while incorporating contemporary design aesthetics.",
    year:'2024',
    link: "https://dribbble.com/shots/25480528-CS-Onam-maveli-laptop-malayalam-typo?utm_source=Clipboard_Shot&utm_campaign=badu01&utm_content=CS%20Onam%20%5Bmaveli%2Blaptop%2Bmalayalam_typo%5D&utm_medium=Social_Share&utm_source=Clipboard_Shot&utm_campaign=badu01&utm_content=CS%20Onam%20%5Bmaveli%2Blaptop%2Bmalayalam_typo%5D&utm_medium=Social_Share",
    type: "graphic",
    src:"dribbble"
  },
];
